module.exports = __webpack_public_path__ + "img/cmb_union_pay-2.c2c309ab.png";